"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerManagerDataAPISymbol = void 0;
exports.ViewerManagerDataAPISymbol = Symbol('viewerManagerDataApi');
//# sourceMappingURL=viewerManagerDataApi.js.map